import { Image } from '@src/core/buyerApiClient';

declare const __APP_ENV__: string | undefined;

export const getImageUrl = (image: Image | null | undefined, style?: string): string | undefined => {
  const styles = image?.styles;

  if (!styles?.length) {
    return undefined;
  }

  if (style) {
    const matchedStyle = styles.find((s) => s.style === style && s.url);

    if (matchedStyle?.url) {
      return matchedStyle.url;
    }
  }

  return styles.find((currentStyle) => currentStyle.url)?.url;
};

export const getTrustedImageUrl = (url: string | null | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }

  if (url.startsWith('https://')) {
    return url;
  }

  const allowHttpInDevelopment = typeof __APP_ENV__ !== 'undefined' && __APP_ENV__ === 'development';

  return allowHttpInDevelopment && url.startsWith('http://') ? url : undefined;
};
